export const roundNumber = (num: number, decmical: number) => {
  return Math.round(num * decmical) / decmical
}
